import React from 'react';
import { ButtonGroup, Button } from '@cimpress/react-components';

const ButtonGroupDemo = () => (
  <div className="row">
    <div className="col-md-6">
      <ButtonGroup variant="justified">
        <Button style={{ minWidth: '100px' }}>Left</Button>
        <Button value="Middle" style={{ minWidth: '100px' }}>
          Middle
        </Button>
        <Button style={{ minWidth: '100px' }}>Right</Button>
      </ButtonGroup>
    </div>
    <div className="col-md-6">
      <ButtonGroup variant="vertical">
        <Button>Button</Button>
        <Button>Button</Button>
        <Button>Button</Button>
        <Button>Button</Button>
        <Button>Button</Button>
      </ButtonGroup>
    </div>
  </div>
);

export default ButtonGroupDemo;
